// extracted by mini-css-extract-plugin
module.exports = {"container":"progress_container__2dolw","text":"progress_text__gZXrl","dot":"progress_dot__1m66O"};